<template>

  <div class="ui grid animated fadeIn">

    <div class="sixteen wide column">

      <div class="ui segment">

        <form class="ui form">
          <div class="fields">
            <div class="two wide field">
              <label class="form-label">CEP</label>
              <span v-if="isObject(quotation.delZipCode)">Antes: {{ quotation.delZipCode.__old.substring(0, 5) + '-' + quotation.delZipCode.__old.substring(5) }}</span>
              <p v-if="isObject(quotation.delZipCode)"></p>
              <span>{{ isObject(quotation.delZipCode) ? quotation.delZipCode.__new.substring(0, 5) + '-' + quotation.delZipCode.__new.substring(5) : quotation.delZipCode.substring(0, 5) + '-' + quotation.delZipCode.substring(5) }}</span>
            </div>                        
            <div class="five wide field">
              <label class="form-label">Endereço</label>
              <span v-if="isObject(quotation.delAddress)">Antes: {{ quotation.delAddress.__old }}</span>
              <p v-if="isObject(quotation.delAddress)"></p>
              <span>{{ isObject(quotation.delAddress) ? quotation.delAddress.__new : quotation.delAddress }}</span>
            </div>
            <div v-if="quotation.delNumber" class="one wide field">
              <label class="form-label">Número</label>
              <span v-if="isObject(quotation.delNumber)">Antes: {{ quotation.delNumber.__old }}</span>
              <p v-if="isObject(quotation.delNumber)"></p>
              <span>{{ isObject(quotation.delNumber) ? quotation.delNumber.__new : quotation.delNumber}}</span>
            </div>
            <div v-if="quotation.delComplement" class="two wide field">
              <label class="form-label">Complemento</label>
              <span v-if="isObject(quotation.delComplement)">Antes: {{ quotation.delComplement.__old }}</span>
              <p v-if="isObject(quotation.delComplement)"></p>
              <span>{{ isObject(quotation.delComplement) ? quotation.delComplement.__new : quotation.delComplement }}</span>
            </div>
            <div class="four wide field">
              <label class="form-label">Munícipio</label>
              <span v-if="isObject(quotation.delCity)">Antes: {{ quotation.delCity }}</span>
              <p v-if="isObject(quotation.delCity)"></p>
              <span>{{ isObject(quotation.delCity) ? quotation.delCity.__new : quotation.delCity }}</span>
            </div>
            <div class="two wide field">
              <label class="form-label">Estado</label>
              <span v-if="isObject(quotation.delState)">Antes: {{ quotation.delState }}</span>
              <p v-if="isObject(quotation.delState)"></p>
              <span>{{ isObject(quotation.delState) ? quotation.delState.__new : quotation.delState }}</span>
            </div>                        
          </div>
          <div class="fields">
            <div class="two wide field">
              <label class="form-label">Frete</label>
              <span v-if="isObject(quotation.freight)">Antes: {{ quotation.freight.__old == 'C' ? 'CIF' : 'FOB' }}</span>
              <p v-if="isObject(quotation.freight)"></p>
              <span>{{ isObject(quotation.freight) ? quotation.freight.__new == 'C' ? 'CIF' : 'FOB' : quotation.freight == 'C' ? 'CIF' : 'FOB' }}</span>
            </div>
            <div class="three wide field">
              <label class="form-label">Tipo Entrega</label>
              <span v-if="isObject(quotation.deliveryType)">Antes: {{ quotation.deliveryType.__old == '1' ? 'Imediata' : 'Programada' }}</span>
              <p v-if="isObject(quotation.deliveryType)"></p>
              <span>{{ isObject(quotation.deliveryType) ? quotation.deliveryType.__new == '1' ? 'Imediata' : 'Programada' : quotation.deliveryType == '1' ? 'Imediata' : 'Programada' }}</span>
            </div>
            <div class="five wide field">
              <label class="form-label">Fat. a partir de</label>
              <span v-if="isObject(quotation.billingDate)">Antes: {{ $formatDate(quotation.billingDate.__old) }}</span>
              <p v-if="isObject(quotation.billingDate)"></p>
              <span>{{ isObject(quotation.billingDate) ? $formatDate(quotation.billingDate.__new) : $formatDate(quotation.billingDate) }}</span>
            </div>                             
          </div>
        </form>

      </div>

    </div>

  </div>

</template>

<script>

  export default {
    props: ["quotation"], 
    methods: {
    isObject(value) {
        if (typeof value == "object" && value != null) {
          return true
        }
        return false
      },
    }   
  }

</script>

